import { classNameGenerator } from "@/utils"
import styles from "./CourseDetails.module.scss"
import Typography from "@/foundation/Typography/V2"
import { Image, SVGSprite } from "@/components/Atoms"
import TimerSection from "../TimerSection"
import { useAppSelector } from "@/hooks"


const CourseDetails = () => {
    const cls = classNameGenerator(styles)
    const { data } = useAppSelector((state) => state.bootCamp);

    if (!data?.courseDetailSection)
        return <></>

    const { title, description, classDetails, courseBannerSection } = data?.courseDetailSection


    const listItems = () => {
        return (
            <ul className={cls("detailList")}>
                {classDetails.map((_val) => {
                    return (
                        <li>
                            <Typography
                                variant="paragraph1"
                                className={cls("description")}
                                dangerouslySetInnerHTML={{ __html: _val }}
                            />
                        </li>
                    )
                })}
            </ul>
        )
    }
    return (
        <section id="CourseDetails">
            <div className={cls("courseDetailContainer")}>
                <div className={cls("courseDetailWrapper")}>
                    <div className={cls("leftSection")}>
                        <Typography
                            variant="heading4"
                            className={cls("title")}
                            dangerouslySetInnerHTML={{ __html: title }}
                        />
                        <Typography
                            variant="span"
                            className={cls("description")}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                        {listItems()}
                        <TimerSection />
                    </div>
                    <div className={cls("rightSection")}>
                        <div className={cls("imgWrapper")}>
                            <Image
                                src={courseBannerSection?.image}
                                alt={"course banner"}
                            />
                        </div>
                        <div className={cls("bottomSection")}>
                            <Typography
                                variant="heading4"
                                className={cls("title")}
                                dangerouslySetInnerHTML={{ __html: courseBannerSection?.title }}
                            />
                            <ul className={cls("tableItems")}>
                                {courseBannerSection?.feature.map((_val) => {
                                    return (
                                        <li>
                                            <div className={cls("left")}>
                                                <SVGSprite
                                                    className={cls("left-icon")}
                                                    icon={_val?.title?.icon}
                                                />
                                                <Typography
                                                    variant="span"
                                                    className={cls("title")}
                                                    dangerouslySetInnerHTML={{ __html: _val?.title?.text }}
                                                />
                                            </div>
                                            <div className={cls("right")}>
                                                {
                                                    _val.label?.icons.map((icon) => {
                                                        return (
                                                            <SVGSprite
                                                                className={cls("right-icon")}
                                                                icon={icon}
                                                            />
                                                        )
                                                    })
                                                }
                                                <Typography
                                                    variant="span"
                                                    className={cls("title")}
                                                    dangerouslySetInnerHTML={{ __html: _val?.label?.text }}
                                                />
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                            <TimerSection />
                        </div>
                    </div>
                    {listItems()}
                </div>
            </div>
        </section>
    )
}


export default CourseDetails